import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import {colorFunctions} from "../../constants/colors";
import {useHistory} from 'react-router-dom';
import backgroundImage from "../../../images/nationwidebackground.png";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {GREY_BACKGROUND} from "../../constants/general-constants";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../../constants/general-constants";
import {COLOR_GRAY_DASHBOARD_BACKGROUND} from "../../constants/general-constants";
import {PURPLE} from "../../constants/general-constants";
import AmChartStacked from "../../components/AmChartStacked";
import {useParams} from "react-router-dom";
import {JWT} from "../../constants/local-storage";
import DashboardSelector from "../../components/DashboardSelector";
import DashboardPhotoNavigator from "../../components/DashboardPhotoNavigator";
import FilterPanel from "../../components/FilterPanel";
import DashboardFilterToolsBottom from "../../components/DashboardFilterToolsBottom";
import DashboardToolPanel from "../../components/DashboardToolPanel";
import {COLOR_DASHBOARD_BACKGROUND} from "../../constants/colors";
import {CARD_STYLE} from "../../constants/styles";
import {CHART_CONTAINER_STYLE} from "../../constants/styles";
import {CARD_HEADER_BACKGROUND} from "../../constants/styles";
import {NON_HERO_BACKGROUND} from "../../constants/styles";
import UtilityDashboardLayout from "../../components/dashboardlayouts/UtilityDashboardLayout";
import {utilityDashboardComponentContainer} from "../../constants/styles";
import ChartCardLarge from "../../components/ChartCardLarge";

export default function UtilisationActivity(){
	
	const globalState = useContext(store);
	const {dispatch} = globalState;
	const history = useHistory();
	
	const [data1, setData1] = useState([]);
	const [data2, setData2] = useState([]);
	const [data3, setData3] = useState([]);
	const [data4, setData4] = useState([]);
	const [graphs1, setGraphs1] = useState([]);
	const [graphs2, setGraphs2] = useState([]);
	const [graphs3, setGraphs3] = useState([]);
	const [graphs4, setGraphs4] = useState([]);
	const [showSignsOfLife, setShowSignsOfLife] = useState(-1);
	const [dataIndex, setDataIndex] = useState(0);
	
	
	const [displayActivityByParentSpaceType, setDisplayActivityByParentSpaceType] = useState("flex");
	const [displayActivityBySpaceType, setDisplayActivityBySpaceType] = useState("none");
	const [displayActivityByParentOrganisation, setDisplayActivityByParentOrganisation] = useState("none");
	const [displayActivityByOrganisation, setDisplayActivityByOrganisation] = useState("none");
	
	const [facilityId, setFacilityId] = useState("-100");
	
	const [loaded, setLoaded] = useState(false);
	
	const utilisationSurveyId =
		    globalState?.state?.queryContext?.utilisationSurveyId ?? null;

	
	useEffect(() => {
		if(loaded === false){
			loadData(dataIndex);
			setLoaded(true);
		}
	
		
		
	}, [dataIndex, utilisationSurveyId]);
	
	const loadData = (dataIndex) => {
		switch(dataIndex) {
		  case 0:
		    loadData1();
		    break;
		  case 1:
		    loadData2();
		    break;
		  case 2:
		    loadData3();
		    break;
		  case 3:
		    loadData4();
		    break;
		  default:
		    loadData1();
		}
	};
	
	const loadData1 = () => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetactivitybyparentspacetype?utilisationSurveyId=" + utilisationSurveyId, setData1, handleData1);
	};
	
	const handleData1 = (obj) => {
		setGraphs1(obj.graphs);
		setData1(obj.returnObjects);
	};
	
	const loadData2 = () => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetactivitybyspacetype?utilisationSurveyId=" + utilisationSurveyId, setData2, handleData2);
	};
	
	const handleData2 = (obj) => {
		setGraphs2(obj.graphs);
		setData2(obj.returnObjects);
	};
	
	const loadData3 = () => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetactivitybyparentorganisation?utilisationSurveyId=" + utilisationSurveyId, setData3, handleData3);
	};
	
	const handleData3 = (obj) => {
		setGraphs3(obj.graphs);
		setData3(obj.returnObjects);
	};
	
	const loadData4 = () => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetactivitybyorganisation?utilisationSurveyId=" + utilisationSurveyId, setData4, handleData4);
	};
	
	const handleData4 = (obj) => {
		setGraphs4(obj.graphs);
		setData4(obj.returnObjects);
	};
  
	
	const refreshFunction = () => {
		loadData(dataIndex);
	};
	
 	
 	const resetDisplay = (index) => {
 		setDataIndex(index);
 		loadData(index);
 		setDisplayActivityBySpaceType("none");
 		setDisplayActivityByParentSpaceType("none");
 		setDisplayActivityByOrganisation("none");
 		setDisplayActivityByParentOrganisation("none");
 	};
 	
 	const showActivityByParentSpaceType = () => {
 		resetDisplay(0);
 		setDisplayActivityByParentSpaceType("flex");
 	};
 	
 	const showActivityBySpaceType = () => {
 		resetDisplay(1);
 		setDisplayActivityBySpaceType("flex");
 	};
 	
 	const showActivityByParentOrganisation = () => {
 		resetDisplay(2);
 		setDisplayActivityByParentOrganisation("flex");
 	};
 	
 	const showActivityByOrganisation = () => {
 		resetDisplay(3);
 		setDisplayActivityByOrganisation("flex");
 	};
 	
 	const toolActions =[
		{label:'Parent Space Type', actionFunction:showActivityByParentSpaceType},
		{label:'Space Type', actionFunction:showActivityBySpaceType},
		{label:'Parent Organisation', actionFunction:showActivityByParentOrganisation},
		{label:'Organisation', actionFunction:showActivityByOrganisation}
	];
 	
	return (
		<UtilityDashboardLayout
					    title="Activity Analysis"
					    childDashboards={childDashboardsUtilisation}
					    refreshFunction={refreshFunction}
					  >
					  
					<div style={{...utilityDashboardComponentContainer, display:displayActivityByParentSpaceType}}>
						<ChartCardLarge title="Activity Grouped By Parent Space Type">
							<AmChartStacked
								chartId="utilisationactivitybyparentspacetype"
								width="100%"
								height="calc(100% - 30px)"
								chartData={data1}
								chartKeys={graphs1}
								categoryKey="name"
							/>
						</ChartCardLarge>
					</div>
					<div style={{...utilityDashboardComponentContainer, display:displayActivityBySpaceType}}>
						<ChartCardLarge title="Activity Grouped By Space Type">
							<AmChartStacked
								chartId="utilisationactivitybyspacetype"
								width="100%"
								height="calc(100% - 30px)"
								chartData={data2}
								chartKeys={graphs2}
								categoryKey="name"
							/>
						</ChartCardLarge>
					</div>
					<div style={{...utilityDashboardComponentContainer, display:displayActivityByParentOrganisation}}>
						<ChartCardLarge title="Activity Grouped By Parent Organisation">
							<AmChartStacked
								chartId="utilisationactivitybyparentorganisation"
								width="100%"
								height="calc(100% - 30px)"
								chartData={data3}
								chartKeys={graphs3}
								categoryKey="name"
							/>
						</ChartCardLarge>
					</div>
					<div style={{...utilityDashboardComponentContainer, display:displayActivityByOrganisation}}>
						<ChartCardLarge title="Activity Grouped By Organisation">
							<AmChartStacked
								chartId="utilisationactivitybyorganisation"
								width="100%"
								height="calc(100% - 30px)"
								chartData={data4}
								chartKeys={graphs4}
								categoryKey="name"
							/>
						</ChartCardLarge>
					</div>			
					<DashboardToolPanel
						title="Choose Chart"
						actions={toolActions}
					/>
		</UtilityDashboardLayout>

	);
}